import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import PeriodSelector from "../../../cylinder/components/history/PeriodSelector";
import { jobcardReport } from "../apiEndpoints";
import { formatDateString } from "../../../../functions/dateTime/formatDateString";
import CustomDateSelector from "../jobcard-history/CustomDateSelector";
import { setError } from "../../../../redux/dataSlice";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import SearchDropdown from "../../../../components/UI/PageInput/SearchDropdown";

const CheckpointReportForm = ({
  checkpointNames,
  getHistory,
  historyError,
  historyErrMsg,
}) => {
  const dispatch = useDispatch();
  const {
    register,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm();
  const { from, to, currentSelector, checkpoint_name } = watch();

  const modifyCheckpointNames = checkpointNames.map((checkpoint) => ({
    name: checkpoint,
  }));

  useEffect(() => {
    if (from && to && checkpoint_name) {
      getHistory(
        jobcardReport(
          formatDateString(from),
          formatDateString(to),
          checkpoint_name,
        ),
      );
    }
  }, [checkpoint_name, from, to]);

  return (
    <form className="bg-white px-3 p-3 mt-3 rounded-lg border-1 border-dBlue-100">
      <div className="flex items-center gap-2">
        <div className="w-1/4">
          <SearchDropdown
            name="checkpoint_name"
            label="Checkpoints"
            keyName="name"
            id="name"
            options={modifyCheckpointNames}
            selectedVal={checkpoint_name}
            search={true}
            setValue={setValue}
            control={control}
          />
        </div>
        <PeriodSelector setValue={setValue} currentSelector={currentSelector} />
        {currentSelector === "custom" && (
          <CustomDateSelector
            from={from}
            to={to}
            register={register}
            setValue={setValue}
            errors={errors}
          />
        )}
      </div>
      {historyError && (
        <ErrorDisplay
          message={historyErrMsg}
          closeAction={() => dispatch(setError("false"))}
        />
      )}
    </form>
  );
};
export default CheckpointReportForm;
